const dataSource = {
    data: {},
    set(key, value) {
        dataSource.data[key] = value;
    },
    get(key) {
        return dataSource.data[key]
    }
}
// window.dataSource = dataSource;
export default dataSource;